export default [
  {
    path: '',
    load: () => import(/* webpackChunkName: 'admin/dashboard' */ './dashboard'),
  },
  {
    path: '/dashboard',
    load: () => import(/* webpackChunkName: 'admin/dashboard' */ './dashboard'),
  },
  {
    path: '/dashboard/:tabName',
    exact: true,
    load: () => import(/* webpackChunkName: 'admin/dashboard' */ './dashboard'),
  },
  {
    path: '/login',
    load: () => import(/* webpackChunkName: 'admin/login' */ './login'),
  },
  {
    path: '/news/edit',
    load: () => import(/* webpackChunkName: 'admin/news/edit' */ './newsEdit'),
  },
  {
    path: '/news/add',
    load: () => import(/* webpackChunkName: 'admin/news/add' */ './newsAdd'),
  },
  {
    path: '/user/edit',
    load: () => import(/* webpackChunkName: 'admin/user/edit' */ './userEdit'),
  },
  {
    path: '/user/add',
    load: () => import(/* webpackChunkName: 'admin/user/add' */ './userAdd'),
  },
  {
    path: '/massmail',
    load: () => import(/* webpackChunkName: 'admin/massmail' */ './massmail'),
  },
  {
    path: '/massmail/add',
    load: () =>
      import(/* webpackChunkName: 'admin/massmail/add' */ './massmail/add'),
  },
  {
    path: '/massmail/edit/:id',
    load: () =>
      import(/* webpackChunkName: 'admin/massmail/edit' */ './massmail/edit'),
  },
  {
    path: '/massmail/delete/:id',
    load: () =>
      import(
        /* webpackChunkName: 'admin/massmail/delete' */ './massmail/delete'
      ),
  },
  {
    path: '/massmail/:id',
    load: () =>
      import(/* webpackChunkName: 'admin/massmail/read' */ './massmail/read'),
  },
  {
    path: '/ads/edit',
    load: () => import(/* webpackChunkName: 'admin/ads/edit' */ './adsEdit'),
  },
  {
    path: '/ads/add',
    load: () => import(/* webpackChunkName: 'admin/ads/add' */ './adsAdd'),
  },
  {
    path: '/suppliers/edit',
    load: () =>
      import(/* webpackChunkName: 'admin/suppliers/edit' */ './supplierEdit'),
  },
  {
    path: '/suppliers/add',
    load: () =>
      import(/* webpackChunkName: 'admin/suppliers/add' */ './supplierAdd'),
  },
  {
    path: '/industrialLinks/add',
    load: () =>
      import(
        /* webpackChunkName: 'admin/industrialLinks/add' */ './industrialLinkAdd'
      ),
  },
  {
    path: '/industrialLinks/edit',
    load: () =>
      import(
        /* webpackChunkName: 'admin/industrialLinks/edit' */ './industrialLinkEdit'
      ),
  },
  {
    path: '/issues/edit',
    load: () =>
      import(/* webpackChunkName: 'admin/issues/edit' */ './issuesEdit'),
  },
  {
    path: '/issues/add',
    load: () =>
      import(/* webpackChunkName: 'admin/issues/add' */ './issuesAdd'),
  },
  {
    path: '/events/edit',
    load: () =>
      import(/* webpackChunkName: 'admin/events/edit' */ './eventsEdit'),
  },
  {
    path: '/events/add',
    load: () =>
      import(/* webpackChunkName: 'admin/events/add' */ './eventsAdd'),
  },
  {
    path: '/publication/add',
    load: () =>
      import(
        /* webpackChunkName: 'admin/publication/add' */ './publicationAdd'
      ),
  },
  {
    path: '/publication/edit',
    load: () =>
      import(
        /* webpackChunkName: 'admin/publication/edit' */ './publicationEdit'
      ),
  },
];
